import { RouteConfig } from 'vue-router';

import { templateAddRoute } from './templateRoute/add.route';
import { templateEditRoute } from './templateRoute/edit.route';
import { templateListRoute } from './templateRoute/list.route';

export const templateRoute: RouteConfig = {
  path: 'template',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  meta: {
    breadcrumb: {
      title: 'Wzory procedury',
      name: 'templateList'
    },
    config: {
      title: 'Wzory procedury',
      name: 'templateList',
      icon: 'fa-file-alt',
      permissions: ['TEMPLATE.UPDATE'],
      group: 'Konfiguracja wzorów'
    }
  },
  children: [templateListRoute, templateAddRoute, templateEditRoute],
  redirect: { name: 'templateList' }
};
